<template>
  <body class="suisFuture-body" id="aboutUs">
    <img
      class="linear"
      src="../../../assets/company/linear-gradient.png"
      alt="linear-gradient"
    />
    <div class="headerAboutUs">
      <TextLabel labelColor="white" labelText="About Us" />
      <div class="headerTitle">Pioneering a Sustainable Future in Commerce</div>
      <div class="headerText">
        At Wecobi, we are driven by a mission to revolutionize the way
        businesses manage unsold inventory, with a focus on sustainability,
        profitability, and social impact.
      </div>
    </div>
    <div class="headerContent">
      <div class="leftSideContent">
        <div class="title">
          Wecobi aims to be the <span> First Point of Discount</span> for the
          <span> $35 trillion </span>
          global retail market. Our innovative platform enables brands to
          transform their deadstock into valuable marketing and
          revenue-generating opportunities.
        </div>
        <div class="text">
          By bridging the gap between unsold goods and conscious consumers, we
          are not only reducing environmental waste but also helping brands
          maintain their integrity and value in an increasingly competitive
          market.
        </div>
        <div class="text">
          At Wecobi, our team is our greatest asset, combining decades of
          experience in retail, e-commerce, media, and technology. Our
          leadership includes industry veterans from global giants like Klarna
          and Shopify, giving us unparalleled insight into the digital commerce
          landscape. Additionally, our team features leading experts in
          sustainability, ensuring that our platform not only drives
          profitability but also promotes a more responsible and environmentally
          conscious future.
        </div>
        <div class="text">
          We're more than just a platform; we're a movement. Our mission is to
          transform the way industries manage their inventory, turning potential
          waste into opportunities for growth and environmental stewardship.
          Whether you're a manufacturer, a brand, or a consumer, Wecobi offers a
          solution that benefits everyone—economically, socially, and
          environmentally.
        </div>
      </div>
      <div class="rightSideContent">
        <div class="stats-wrapper">
          <div class="stats-title">In 58</div>
          <div class="stats-text">countries and growing</div>
        </div>
        <div class="line"></div>
        <div class="stats-wrapper">
          <div class="stats-title">700k</div>
          <div class="stats-text">metric tons of CO2 saved by 2030</div>
        </div>
        <div class="line"></div>
        <div class="stats-wrapper">
          <div class="stats-title">1.8m</div>
          <div class="stats-text">people reached with a single campaign</div>
        </div>
      </div>
    </div>
    <img
      class="image"
      src="../../../assets/company/wecobi-about-us.png"
      alt="wecobi-about-us"
    />
  </body>
</template>

<script>
import TextLabel from "@/components/Sustainability/Content/ReusableComponents/TextLabel.vue";
export default {
  name: "AboutUs",
  components: {
    TextLabel,
  },
};
</script>

<style scoped>
.suisFuture-body {
  width: 100%;
  height: fit-content;
  background-color: #000000;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 140px;
  padding-bottom: 100px;
  padding: 120px 180px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}
.headerAboutUs {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  max-width: 682px;
}
.headerTitle {
  font-size: 40px;
  font-weight: 600;
  line-height: 1.2;
}
.headerText {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
}

.headerTitle,
.headerText {
  color: #ffffff;
  text-align: center;
}
.headerContent {
  display: flex;
  justify-content: space-between;
  gap: 140px;
}

.leftSideContent {
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 953px;
  color: #ffffff;
}

.title {
  font-size: 22px;
  font-weight: 500;
  line-height: 1.5;
}
.text {
  font-size: 18px;
  font-weight: 300;
  line-height: 1.7;
}
span {
  color: #ff6d0a;
  font-weight: 700;
}

.rightSideContent {
  max-width: 217px;
  display: flex;
  flex-direction: column;
  gap: 34px;
}
.stats-wrapper {
  display: flex;
  flex-direction: column;
  color: #ff6d0a;
}

.stats-title {
  font-size: 55px;
  font-weight: 700;
  line-height: 1.5;
}
.stats-text {
  font-size: 20px;
  font-weight: 500;
  line-height: 1.4;
}

.line {
  width: 100%;
  height: 2px;
  background-color: #e6e6f3;
  opacity: 0.3;
  border-radius: 20px;
}
.image-wrapper {
  width: 100%;
  border: 2px solid orange;
  display: flex;
  justify-content: center;
  position: relative;
}
.image {
  width: 410px;
  height: 281px;
}

.linear {
  position: absolute;
  width: 100%;
  height: 219px;
  bottom: 140px;
  left: 0;
}

@media (max-width: 1280px) {
  .suisFuture-body {
    padding: 120px;
  }
  .leftSideContent {
    max-width: 615px;
  }
  .text {
    font-size: 16px;
  }
}
@media (max-width: 1024px) {
  .suisFuture-body {
    padding: 80px;
    gap: 60px;
  }
  .leftSideContent {
    max-width: 520px;
    gap: 20px;
  }
  .title {
    font-size: 20px;
  }
  .text {
    font-size: 14px;
  }
  .headerContent {
    gap: 80px;
  }
  .rightSideContent {
    gap: 25px;
  }
  .stats-title {
    font-size: 45px;
  }
  .stats-text {
    font-size: 18px;
  }
  .image {
    width: 341px;
    height: 234px;
  }
  .linear {
    bottom: 95px;
  }
}
@media (max-width: 744px) {
  .suisFuture-body {
    padding: 80px 50px;
  }
  .headerAboutUs {
    max-width: 538px;
  }
  .headerTitle {
    font-size: 30px;
  }
  .headerText {
    font-size: 14px;
  }
  .leftSideContent {
    max-width: 439px;
  }
  .stats-title {
    font-size: 35px;
  }
  .stats-text {
    font-size: 14px;
  }
}

@media (max-width: 588px) {
  .suisFuture-body {
    padding: 60px 40px;
    gap: 40px;
  }
  .headerAboutUs {
    max-width: 414px;
  }
  .headerTitle {
    font-size: 25px;
  }
  .headerText {
    font-size: 12px;
  }
  .headerContent {
    gap: 40px;
  }
  .leftSideContent {
    max-width: 326px;
  }
  .title {
    font-size: 18px;
  }
  .text {
    font-size: 12px;
  }
  .stats-title {
    font-size: 35px;
  }
  .stats-text {
    font-size: 14px;
  }
  .image {
    width: 215px;
    height: 147px;
  }
  .linear {
    bottom: 30px;
  }
}

@media (max-width: 431px) {
  .suisFuture-body {
    padding: 60px 30px;
    gap: 40px;
  }
  .headerAboutUs {
    max-width: 338px;
  }
  .headerContent {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
  .leftSideContent {
    width: 100%;
  }
  .rightSideContent {
    align-items: center;
    gap: 20px;
  }
  .stats-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ff6d0a;
    text-align: center;
  }

  .stats-title {
    font-size: 30px;
  }

  .line {
    width: 112px;
  }
}
</style>
